import { UserAlias } from '../../slices/account-api.slice';

export const primaryAlias: UserAlias = { alias: 'rick1@yadkrow.com', type: 'EMAIL', primary: true };

export const emailAliases: UserAlias[] = [
    { alias: 'rick3@yadkrow.com', type: 'EMAIL', primary: false },
    { alias: 'rick2@yadkrow.com', type: 'EMAIL', primary: false },
    primaryAlias
];
